import React, { useState } from 'react';
import { CalculatorIcon, DocumentIcon, TrendingIcon, MapIcon } from '../Icons/Icons';
import LoanCalculator from '../LoanCalculator/LoanCalculator';
import AreaConverter from '../AreaConverter/AreaConverter';
import PropertyTrends from '../PropertyTrends/PropertyTrends';
import MapsPreview from '../MapsPreview/MapsPreview';
import './RealEstateTools.css';

function RealEstateTools() {
  const [activeTool, setActiveTool] = useState(null);

  const tools = [
    {
      id: 'loan-calculator',
      title: 'Home Loan Calculator',
      description: 'Calculate your monthly mortgage payments',
      icon: <CalculatorIcon size={32} color="var(--color-primary)" />,
      component: LoanCalculator
    },
    {
      id: 'area-converter',
      title: 'Area Unit Converter',
      description: 'Convert between different area units',
      icon: <DocumentIcon size={32} color="var(--color-primary)" />,
      component: AreaConverter
    },
    {
      id: 'property-trends',
      title: 'Property Trends',
      description: 'View latest market trends and insights',
      icon: <TrendingIcon size={32} color="var(--color-primary)" />,
      component: PropertyTrends
    },
    {
      id: 'maps-locations',
      title: 'Maps & Locations',
      description: 'Explore properties on interactive maps',
      icon: <MapIcon size={32} color="var(--color-primary)" />,
      component: MapsPreview
    }
  ];

  const handleToolClick = (toolId) => {
    setActiveTool(toolId);
  };

  const handleCloseTool = () => {
    setActiveTool(null);
  };

  const ActiveToolComponent = tools.find(tool => tool.id === activeTool)?.component;

  return (
    <>
      <section className="real-estate-tools">
        <div className="container">
          <div className="section-header">
            <h2>Real Estate Tools</h2>
            <p>Helpful tools to make your property search easier</p>
          </div>

          <div className="tools-grid">
            {tools.map(tool => (
              <div key={tool.id} className="tool-card">
                <div className="tool-icon">{tool.icon}</div>
                <h3>{tool.title}</h3>
                <p>{tool.description}</p>
                <button
                  className="btn-tool"
                  onClick={() => handleToolClick(tool.id)}
                  aria-label={`Open ${tool.title}`}
                >
                  Try Now
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {ActiveToolComponent && <ActiveToolComponent onClose={handleCloseTool} />}
    </>
  );
}

export default RealEstateTools;
